<script>
    // -- IMPORTS

    import AdminEditButton from '$lib/component/element/AdminEditButton.svelte';
    import { enabledAdminView } from '$lib/store/adminStore.js';
    import AmbassadorBlock from '../ambassadors/AmbassadorBlock.svelte';
    import NewBlockDivider from '../element/NewBlockDivider.svelte';
    import AnimatedText from '../element/AnimatedText.svelte';
    import { getProcessedMultilineTranslatedText } from '$src/lib/base';
    import { textStore } from '$src/lib/store/textStore';
    import { languageTagStore } from '$src/lib/store/languageTagStore';
    import PageHeading from '../header/PageHeading.svelte';

    // -- VARIABLES

    let {
            internalTeamArray,
            ambassadorTeamArray,
            expertTeamArray,
            foundingTeamArray
        } = $props();

    const bamhubTeams = {
        internal:
        {
            label: 'internal-team-label',
            teamArray: internalTeamArray
        },
        ambassador:
        {
            label: 'ambassador-team-label',
            teamArray: ambassadorTeamArray
        },
        expert:
        {
            label: 'expert-team-label',
            teamArray: expertTeamArray
        },
        // founding:
        // {
        //     label: 'founding-team-label',
        //     teamArray: foundingTeamArray
        // }
    };
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../../constant.styl';
    @import '../../../mixin.styl';

    // -- CLASSES

    .manager-section
    {
        border: 1px solid borderColor;
        padding: 1rem 2rem;

        display: flex;
        flex-direction: column;
        gap: 6rem;
        margin: 0;

        +media( desktop )
        {
            padding: 5rem 2rem;
            max-width: 77vw;
            border: none;
        }
    }
</style>

<div class="manager-container">
    <!-- <NewBlockDivider pageId={ "RObykSt8nN4BT5ligbvqlA" } isManager={ true } /> -->

    {#each Object.entries( bamhubTeams ) as [ teamKey, { label, teamArray } ] }

        <PageHeading
            title={ getProcessedMultilineTranslatedText( $textStore[ label ], $languageTagStore ) }
        />
        
        <!-- <span class="heading-title color-light-gold" class:is-admin-enabled={ $enabledAdminView }>
            <AnimatedText text={ getProcessedMultilineTranslatedText( $textStore[ label ], $languageTagStore ) } />
            <AdminEditButton
                type="text"
                slug={ label }
                inset="-2.5rem -1rem auto auto"
                textToEdit={ $textStore[ label ] }
                title={ label }
            />
        </span> -->
        <section class="manager-section">
            {#each teamArray as { id, name, position, mediaPath, mediaPathArray, biography, imageSide, linkedinLink, emailAddress, instagramLink, number } }
                <AmbassadorBlock
                    id={ id }
                    name={ name }
                    position={ position }
                    mediaPath={ mediaPath }
                    mediaPathArray={ mediaPathArray }
                    biography={ biography }
                    imageSide={ imageSide }
                    linkedinLink={ linkedinLink }
                    emailAddress={ emailAddress }
                    instagramLink={ instagramLink }
                    number={ number }
                    isFounder={ id === 'RrkYCpAAw2U4gZPIap68GA' || id === 'uYn2C92eC-TLewxiJkEwtQ' }
                />
            {/each}
        </section>
    {/each}
</div>
